import { Link } from 'react-router-dom';

const exploreLinks: Array<{ label: string; to: string }> = [
  { label: 'Wineries', to: '/wineries' },
  { label: 'Tasting Experiences', to: '/experiences' },
  { label: 'Events', to: '/events' },
  { label: 'Itineraries', to: '/itineraries' },
];

const learnLinks: Array<{ label: string; to: string }> = [
  { label: 'Wine Tasting FAQs', to: '/wine-tasting-faq' },
  { label: 'WineryXplorer Blog', to: '/wineryxplorer-blog' },
  { label: 'Help', to: '/help' },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        {/* Columns */}
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-8 md:gap-12">
          {/* Brand col */}
          <div>
            <img
              src="/winex-logo.png"
              alt="WineryXplorer"
              className="h-7 w-auto mb-3"
            />
            <p className="text-sm font-sans text-gray-700 leading-relaxed max-w-[30ch]">
              From hidden gems to iconic estates, WineryXplorer helps you
              discover wine country experiences tailored to your tastes.
            </p>
          </div>

          {/* Mobile-only: 2-col grid for the two link cols. Desktop they're inline columns. */}
          <div className="grid grid-cols-2 gap-8 md:contents">
            {/* Explore */}
            <div>
              <h2 className="text-xs font-sans font-semibold uppercase tracking-[0.16em] text-gray-900 mb-3">
                Explore
              </h2>
              <ul className="space-y-2">
                {exploreLinks.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="text-[15px] font-sans text-gray-700 hover:text-primary-700 transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Learn */}
            <div>
              <h2 className="text-xs font-sans font-semibold uppercase tracking-[0.16em] text-gray-900 mb-3">
                Learn
              </h2>
              <ul className="space-y-2">
                {learnLinks.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="text-[15px] font-sans text-gray-700 hover:text-primary-700 transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* For Wineries */}
            <div>
              <h2 className="text-xs font-sans font-semibold uppercase tracking-[0.16em] text-gray-900 mb-3">
                For Wineries
              </h2>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/listings"
                    className="text-[15px] font-sans text-gray-700 hover:text-primary-700 transition-colors"
                  >
                    Manage Your Listings
                  </Link>
                </li>
                <li>
                  <Link
                    to="/report-errors"
                    className="text-[15px] font-sans text-gray-700 hover:text-primary-700 transition-colors"
                  >
                    Feedback / Report Errors
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="mt-10 pt-4 border-t border-gray-200 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 text-sm font-sans text-gray-500">
          <span>© {year} WineryXplorer. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/about" className="hover:text-primary-700 transition-colors">
              About
            </Link>
            <Link to="/privacy" className="hover:text-primary-700 transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-primary-700 transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
